import { useTranslations } from '@vocab/react';
import { IconMoney, Text } from 'braid-design-system';

import type {
  SalaryFrequency,
  Salary as SalaryType,
} from '../../../types/profile.types';

import translations from './.vocab';

interface Props {
  salary: SalaryType;
}

export const Salary = ({ salary: { currency, expected, type } }: Props) => {
  const { t } = useTranslations(translations);

  const displaySalaryFromSalaryType: Record<SalaryFrequency, string> = {
    ['HOURLY']: t('HOURLY_SALARY', {
      currency,
      expected,
    }),
    ['MONTHLY']: t('MONTHLY_SALARY', {
      currency,
      expected,
    }),
    ['ANNUAL']: t('ANNUAL_SALARY', {
      currency,
      expected,
    }),
  };

  return (
    <Text
      icon={<IconMoney tone="secondary" data={{ testid: 'money-icon' }} />}
      size="small"
    >
      {displaySalaryFromSalaryType[type]}
    </Text>
  );
};
